/**
 * Fetches Excel file as ArrayBuffer from a blob URL.
 * @param url - Blob URL of the Excel file
 */
export const fetchExcelData = async (url: string): Promise<ArrayBuffer> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch Excel file: ${response.statusText}`);
  }
  return await response.arrayBuffer();
};
